import { useQuery } from '@apollo/client'

import useAuth from 'data/gradoo/hooks/useAuth'
import { GET_PROJECTS } from 'data/layoutcreator/queries/projects'
import Head from 'shared/components/Head'
import PageContainer from 'shared/components/PageContainer'
import { useLiveUsers } from 'shared/hooks/useLiveUsers'
import DefaultLayout from 'shared/layout/Default'
import SectionHeader from 'shared/ui/SectionHeader'

import YearbookCard from '../../shared/ui/YearbookCard'
import Cards from './components/Cards'

const Home = () => {
  const liveUsers = useLiveUsers()
  const {
    authGroupId,
    loading: authLoading,
    error: authError
  } = useAuth()

  const {
    loading: projectsLoading,
    error: projectsError,
    data: projectsData
  } = useQuery(GET_PROJECTS, {
    skip: !authGroupId,
    variables: { groupId: authGroupId as string }
  })

  const loading = authLoading || projectsLoading

  const error = authError || projectsError

  const projects = projectsData?.projects || []

  return (
    <>
      <Head titleId="Projects.title" />
      <DefaultLayout liveUsers={liveUsers}>
        <PageContainer>
          <SectionHeader
            titleId="Home.lets.start"
            marginTop={48}
            marginBottom={22}
          />
          {loading && <p>Loading...</p>}
          {error && <p>Error :(</p>}
          <Cards>
            {projects.map(project => (
              <YearbookCard
                key={project.id}
                linkTo={`${project.id}?view=grid`}
                name={project.name}
                lastUpdate={project?.lastUpdate ?? null}
                pagePreviews={project.pagePreviews}
              />
            ))}
          </Cards>
        </PageContainer>
      </DefaultLayout>
    </>
  )
}

export default Home
